export default __webpack_public_path__ + "static/media/preloader.08e730ba.gif";